import { render, staticRenderFns } from "./PostInnerSection.vue?vue&type=template&id=cabbf5ac&scoped=true&"
import script from "./PostInnerSection.vue?vue&type=script&lang=js&"
export * from "./PostInnerSection.vue?vue&type=script&lang=js&"
import style0 from "./PostInnerSection.vue?vue&type=style&index=0&id=cabbf5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbf5ac",
  null
  
)

export default component.exports